import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Layout
import Layout from './components/Layout/Layout';

// Pages (placeholders for now)
import Home from './pages/Home';
import CourseCatalog from './pages/CourseCatalog';
import CourseView from './pages/CourseView';
import LessonView from './pages/LessonView';
import ProjectView from './pages/ProjectView';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#000000',
            color: '#fff',
            border: '1px solid #84cc16',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#84cc16',
              secondary: '#000',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="courses" element={<CourseCatalog />} />
          <Route path="courses/:courseId" element={<CourseView />} />
          <Route path="lessons/:lessonId" element={<LessonView />} />
          <Route path="projects/:projectId" element={<ProjectView />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;




